import { render, staticRenderFns } from "./addUserFromCourse.vue?vue&type=template&id=cdc3a636&"
import script from "./addUserFromCourse.js?vue&type=script&lang=js&"
export * from "./addUserFromCourse.js?vue&type=script&lang=js&"
import style0 from "./addUserFromCourse.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports